import { EnvironmentInterface } from './environment.interface';

export const environment: EnvironmentInterface = {
  production: import.meta.env?.['NG_APP_ENV'].includes('production'),
  apiHost: import.meta.env?.['NG_APP_API_HOST'],
  loadDataPeriod: import.meta.env?.['NG_APP_LOAD_DATA_PERIOD'] ?? 15000,
  defaultLocale: import.meta.env?.['NG_APP_DEFAULT_LOCALE'],
  telegramBotId: import.meta.env?.['NG_APP_TELEGRAM_BOT_ID'],
  newRoleModel: import.meta.env?.['NG_APP_NEW_ROLE_MODEL'] == true,
  cliVisible: import.meta.env?.['NG_APP_CLI_VISIBLE'] == true,
  keycloak: {
    enabled: import.meta.env?.['NG_APP_KEYCLOAK_ENABLED'] == true,
    url: import.meta.env?.['NG_APP_KEYCLOAK_URL'],
    clientId: import.meta.env?.['NG_APP_KEYCLOAK_CLIENT_ID'],
    realm: import.meta.env?.['NG_APP_KEYCLOAK_REALM'],
    standardFlow:
      import.meta.env?.['NG_APP_ENABLE_STANDARD_KEYCLOAK_FLOW'] == true,
  },
  authIgnore: {
    enabled: import.meta.env?.['NG_APP_AUTH_IGNORE_ENABLED'] == true,
    login: import.meta.env?.['NG_APP_AUTH_IGNORE_ACCOUNT_EMAIL'],
    keycloakId: import.meta.env?.['NG_APP_AUTH_IGNORE_ACCOUNT_KEYCLOAK_ID'],
    name: import.meta.env?.['NG_APP_AUTH_IGNORE_ACCOUNT_NAME'],
    email: import.meta.env?.['NG_APP_AUTH_IGNORE_ACCOUNT_EMAIL'],
  },
  amplitude: {
    enabled: import.meta.env?.['NG_APP_AMPLITUDE_ENABLED'] == true,
    apiKey: import.meta.env?.['NG_APP_AMPLITUDE_API_KEY'],
    logLevel: import.meta.env?.['NG_APP_AMPLITUDE_LOG_LEVEL'] ?? 0,
  },
  googleAnalytics: {
    enabled: import.meta.env?.['NG_APP_GOOGLE_ANALYTICS_ENABLED'] == true,
    gaTrackingId: import.meta.env?.['NG_APP_GOOGLE_ANALYTICS_TRACK_ID'],
  },
  sentry: {
    enabled: import.meta.env?.['NG_APP_SENTRY_ENABLED'] == true,
    dsn: import.meta.env?.['NG_APP_SENTRY_DSN'],
    environment: import.meta.env?.['NG_APP_SENTRY_ENVIRONMENT'],
  },
  vendor: {
    name: import.meta.env?.['NG_APP_VENDOR_NAME'],
    legalName: import.meta.env?.['NG_APP_VENDOR_LEGAL_NAME'],
    osName: import.meta.env?.['NG_APP_VENDOR_OS_NAME'],
    dnsName: import.meta.env?.['NG_APP_VENDOR_DNS_NAME'],
    dnsExample: import.meta.env?.['NG_APP_VENDOR_DNS_EXAMPLE'],
    supportUrl: import.meta.env?.['NG_APP_VENDOR_SUPPORT_URL'],
    docsUrl: import.meta.env?.['NG_APP_VENDOR_DOCS_URL'],
    forumUrl: import.meta.env?.['NG_APP_VENDOR_FORUM_URL'],
  },
};
